import React, {useState, useEffect} from 'react';
import reload from "../../assets/reload.svg";
import upArrow from "../../assets/uparrowFilter.svg";
import downArrow from "../../assets/downarrowFilter.svg";
import moment from 'moment';
import { Button } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import { IRoot } from '../../services/interface/IHome';
import { IRoot as IDemandRoot } from '../../services/interface/IDemand';
import { IAdEffectivenessDrill, IAPITableData, IEffectivessFilter, IStoreLevelFilter, IWeeklyDataItem } from '../../services/interface/IAdEffectiveness';
import FilterComponent from '../../components/FilterComponent';
import { formatFilterName } from '../../utils/formatter';
import {Table} from 'rsuite';
import { useGetAdEffectivenessDropdownFilterMutation } from '../../services/redux/api/adEffectiveness';
import { useGetAdTable } from '../../services/redux/hooks/useAdEffectiveness';
import { setApplyFilter } from '../../services/redux/reducer/demandfilter.reducer';
import CustomLoader from '../../common/CustomLoader/CustomLoader';
const { ColumnGroup, Column, HeaderCell, Cell } = Table;

const AdEffectiveness = () => {

    const dispatch = useDispatch();
    const [isVisible, setIsVisible] = useState<boolean>(true);
    const initialState:IEffectivessFilter = {
        divisionName: [],
        dc: [],
        category: [],
        subCategory: [],
        line: [],
        class: [],
    }

    const [drillIdSelected, setDrillIdSelected] = useState<IAdEffectivenessDrill>({
        dcIdSelected: undefined,
        categoryIdSelected: undefined,
        subCategoryIdSelected: undefined,
    })
    const [drillDownFilterKey, setDrillDownFilterKey] = useState<string[]>(["branchid"]);
    const [sortColumn, setSortColumn] = useState('');
    const [sortType, setSortType] = useState();
    const [selectedFilterData, setSelectedFilterData] = useState<IEffectivessFilter>(initialState);
    const [filters, setFilters] = useState<IEffectivessFilter>(initialState);

    const [tableData, setTableData] = useState<IAPITableData>();
    const [transformedData, setTransformedData] = useState<any>();
    const applyFilter = useSelector((state:IDemandRoot)=>state.dbfilter.applyFilter);
    const lastUpdated = useSelector((state: IRoot) => state.filter.lastUpdateDate) || "";
    const {mutate: getAdTableData, isLoading, isSuccess, resetData, cached} = useGetAdTable();
    const [getFilterData, {isLoading: isFilterLoading, data: AdFilter}] = useGetAdEffectivenessDropdownFilterMutation();

    const handleSortColumn = (sortColumn: any, sortType: any) => {
        setSortColumn(sortColumn);
        setSortType(sortType);
    };

    const splitParts = (str: string) => {
        return String(str).split(/(\d+)/).map((part: string, index: number) => {
            return index % 2 === 1 ? parseInt(part, 10) : part;
        });
    };

    const naturalSort = (a: { [x: string]: string; }, b: { [x: string]: string; }) => {
        const aParts = splitParts(a[sortColumn]);
        const bParts = splitParts(b[sortColumn]);

        for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
            const aPart = aParts[i];
            const bPart = bParts[i];

            if (aPart !== bPart) {
                if (typeof aPart === 'number' && typeof bPart === 'number') {
                    return aPart - bPart;
                }
                return aPart > bPart ? 1 : -1;
            }
        }
        return 0;
    };

    const getSortedData = () => {
        if (sortColumn && sortType) {
            return [...transformedData].sort((a, b) => {
                const result = naturalSort(a, b);
                return sortType === 'asc' ? result : -result;
            });
        }
        return transformedData;
    };
    const sortedData = getSortedData();

    const filterNamesMap: { [key: string]: string } = {
        dc: "DC",
        productSegm: "Segmentation",
        vendorName: "Vendor"
    };
    const filterShowHandler=()=>{
        setIsVisible(!isVisible);
    }

    const handleFilterChange = (filterKey: string, value: string | string[]) => {
        const newValue = Array.isArray(value) ? value : [value];
        setSelectedFilterData(prevState => ({
            ...prevState,
            [filterKey]: newValue,
        }));
    };

    const applyHandler=()=>{
        dispatch(setApplyFilter("applied"));
    }

    const removeHandler=()=>{
        setSelectedFilterData(initialState);
        dispatch(setApplyFilter(""));
    }
      
    const transformData = (data: IAPITableData, drillDownFilterKey="branchid") => {
        const transformedData: any = {};
        const weekDates: (string | Date)[] = [];

        // Populate transformedData
        data?.weeklyData.forEach((week: { weekStartDate: string | Date; data: any[]; }) => {
            const { weekStartDate, data } = week;
            weekDates.push(weekStartDate);

            data.forEach((dc: { dcName: string; adType: string; unitPrice: number; volumeAdLift: number; category: any; subCategory: any, itemid: any }) => {
                const { dcName, adType, unitPrice, volumeAdLift, category, subCategory, itemid } = dc;

                if(drillDownFilterKey === "branchid"){
                    if (!transformedData[dcName]) {
                        transformedData[dcName] = { DC: dcName };
                    }
    
                    transformedData[dcName][`${weekStartDate}_adType`] = adType ?? 0;
                    transformedData[dcName][`${weekStartDate}_unitPrice`] = unitPrice ?? 0;
                    transformedData[dcName][`${weekStartDate}_volumeAdLift`] = volumeAdLift ?? 0;
                }
                else if(drillDownFilterKey === "category"){
                    if (!transformedData[category]) {
                        transformedData[category] = { category: category };
                    }
    
                    transformedData[category]["DC"] = dcName;
    
                    transformedData[category][`${weekStartDate}_adType`] = adType ?? 0;
                    transformedData[category][`${weekStartDate}_unitPrice`] = unitPrice ?? 0;
                    transformedData[category][`${weekStartDate}_volumeAdLift`] = volumeAdLift ?? 0;
                }
                else if(drillDownFilterKey === "subCategory"){
                    if (!transformedData[subCategory]) {
                        transformedData[subCategory] = { subCategory: subCategory };
                    }
    
                    transformedData[subCategory]["DC"] = dcName;
                    transformedData[subCategory]["category"] = category;
    
                    transformedData[subCategory][`${weekStartDate}_adType`] = adType ?? 0;
                    transformedData[subCategory][`${weekStartDate}_unitPrice`] = unitPrice ?? 0;
                    transformedData[subCategory][`${weekStartDate}_volumeAdLift`] = volumeAdLift ?? 0;
                }
                else if(drillDownFilterKey === "itemId"){
                    if (!transformedData[itemid]) {
                        transformedData[itemid] = { itemid: itemid };
                    }
    
                    transformedData[itemid]["DC"] = dcName;
                    transformedData[itemid]["category"] = category;
                    transformedData[itemid]["subCategory"] = subCategory;
    
                    transformedData[itemid][`${weekStartDate}_adType`] = adType ?? 0;
                    transformedData[itemid][`${weekStartDate}_unitPrice`] = unitPrice ?? 0;
                    transformedData[itemid][`${weekStartDate}_volumeAdLift`] = volumeAdLift ?? 0;
                }
            });
        });

        return Object.values(transformedData);
    };

    const weeks = tableData?.weeklyData.map((week: { weekStartDate: string; }) => week?.weekStartDate);

    const callAdEffectivenessApi=async(
        drillDownFilter:string[]=[],
        storeLevel:IStoreLevelFilter,
        preferredStoreLevel={dc:[],category:[],subCategory:[]},
        isClicked:boolean = false)=>{
        try {
            const {dc,category,subCategory} = preferredStoreLevel;
            let payload;
            if(isClicked){
                payload = {
                    ...selectedFilterData,
                    dc,
                    category,
                    subCategory,
                    drillDownFilter,
                    storeLevel
                }
            }else{
                payload = {
                    ...selectedFilterData,
                    drillDownFilter,
                    storeLevel
                }
            }
            const response = await getAdTableData(
                payload as any
            ).unwrap();
            setTableData(response?.data);
            let local;
            if(drillDownFilter[3] === "itemId"){
                local = transformData(response?.data, "itemId");
            }
            else if(drillDownFilter[2] === "MDM_L3"){
                local = transformData(response?.data, "subCategory");
            }
            else if(drillDownFilter[1] === "MDM_L2"){
                local = transformData(response?.data,"category");
            }
            else if(drillDownFilter[0] == "branchid"){
                local = transformData(response?.data,"branchid");
            }
            setTransformedData(local);
        } catch (error) {
            console.error("Failed to fetch forecast filter data:", error);
        }
    }

    const callForecastFilterApi = async () => {
        try {
          const payload = {
            ...selectedFilterData,
          }
          const response = await getFilterData(
            payload as any
          ).unwrap();
          setFilters(prevFilters => ({
            divisionName: response?.data?.divisionName || [],
            dc: response?.data?.dc || [],
            category: response?.data.category || [],
            subCategory: response?.data?.subCategory || [],
            line: response?.data?.line || [],
            class: response?.data?.class || [],
          }));
    
        } catch (error) {
          console.error("Failed to fetch forecast filter data:", error);
        }
    };

    // To Drill down
    const handleRowClick = (rowData: any) => {
        let drillDownFilter: string[] = ["branchid"];
    
        let storeLevel = {
            branchid: "",
            category: "",
            subCategory: ""
        };
    
        if (!rowData) {
            return;
        }
    
        const branchid = rowData?.DC;
        const MDM_L2 = rowData?.category;
        const MDM_L3 = rowData?.subCategory;
    
        if (MDM_L3 && MDM_L2 && branchid && rowData?.itemid) {
            return;
        }
    
        if (MDM_L3 && MDM_L2 && branchid) {
            storeLevel = { branchid, category: MDM_L2, subCategory: MDM_L3 };
            drillDownFilter.push("MDM_L2", "MDM_L3", "itemId");
        } else if (!MDM_L3 && MDM_L2 && branchid) {
            storeLevel = { branchid, category: MDM_L2, subCategory: "" };
            drillDownFilter.push("MDM_L2", "MDM_L3");
        } else if (!MDM_L3 && !MDM_L2 && branchid) {
            storeLevel = { branchid, category: "", subCategory: "" };
            drillDownFilter.push("MDM_L2");
        } else {
            return;
        }
    
        setDrillDownFilterKey(drillDownFilter);
    
        setDrillIdSelected((prevState) => ({
            ...prevState,
            dcIdSelected: branchid,
            categoryIdSelected: MDM_L2,
            subCategoryIdSelected: MDM_L3
        }));

        const preferredStoreLevel:any = {
            dc: selectedFilterData?.dc.length > 0 ? branchid ? [] : [] : [],
            category: selectedFilterData?.category.length > 0 ? MDM_L2 ? [] : [] : [],  
            subCategory : selectedFilterData?.subCategory.length > 0 ? MDM_L3 ? [] : [] : [],
        }
        // If true, means row is clicked
        callAdEffectivenessApi(drillDownFilter, storeLevel, preferredStoreLevel, true);
    }    

    // To Drill Up
    const handleAdEffectiveness=(level=1)=>{
        if(level == 1){
            setDrillIdSelected({
                ...drillIdSelected,
                dcIdSelected: undefined,
                categoryIdSelected: undefined,
                subCategoryIdSelected: undefined
            });
            setDrillDownFilterKey(["branchid"]);
            callAdEffectivenessApi(["branchid"],{branchid:"",category:"",subCategory:""});
        }
        else if(level == 2){
            setDrillIdSelected({
                ...drillIdSelected,
                categoryIdSelected: undefined,
                subCategoryIdSelected: undefined
            })
            setDrillDownFilterKey(["branchid","MDM_L2"]);
            callAdEffectivenessApi(["branchid","MDM_L2"],{branchid:drillIdSelected?.dcIdSelected, category:"", subCategory:""});
        }
        else if(level === 3){
            setDrillIdSelected({
                ...drillIdSelected,
                subCategoryIdSelected: undefined,
            });
            setDrillDownFilterKey(["branchid","MDM_L2","MDM_L3"]);
            callAdEffectivenessApi(["branchid","MDM_L2","MDM_L3"],{branchid:drillIdSelected?.dcIdSelected, category:drillIdSelected?.categoryIdSelected , subCategory:""});
        }
    }
    
    useEffect(()=>{
        callForecastFilterApi();
    },[]);

    useEffect(()=>{
        if(applyFilter === ""){
            callAdEffectivenessApi(["branchid"],{branchid:"",category:"",subCategory:""});
            setDrillIdSelected({
                ...drillIdSelected,
                dcIdSelected: undefined,
                categoryIdSelected: undefined,
                subCategoryIdSelected: undefined
            })
        }
        else if(applyFilter === "applied"){
            const { dcIdSelected="", categoryIdSelected="", subCategoryIdSelected="" } = drillIdSelected;
            callAdEffectivenessApi(
                drillDownFilterKey, 
                {
                    branchid: dcIdSelected, 
                    category: categoryIdSelected, 
                    subCategory: subCategoryIdSelected
                });
        }
    },[applyFilter])


    return (
        <>
            <div className="flex flex-col justify-start items-start bg-[#f1f1f1] gap-[2vh] w-full h-[82vh]">
                {/* Filters */}
                <div className="relative w-full bg-[#FFF]">
                    <div className={`flex flex-col gap-1 px-[2%] border-b-[1px] shadow ${!isVisible ? "pt-[8px] pb-[2px]" : "pt-[8px] pb-[15px]"}`}>
                        <div className="flex justify-between items-center mb-1">
                            <h3 className="page-title font-semibold">
                                {"Promotions & Assessment > "}
                                {(drillIdSelected?.dcIdSelected!=undefined || 
                                (drillIdSelected?.dcIdSelected && String(drillIdSelected?.dcIdSelected)?.length > 0)) && tableData ? (
                                    <>
                                        
                                        <span
                                            className="underline underline-offset-2 text-blue-500"
                                            onClick={()=>handleAdEffectiveness(1)}
                                        >
                                            <a
                                                href=""
                                                onClick={($event) => {
                                                    $event.preventDefault();
                                                }}
                                            >
                                                {"Ad Effectiveness"}
                                            </a>
                                        </span>
                                        {drillIdSelected?.dcIdSelected && !drillIdSelected?.categoryIdSelected && <span>{` > ${drillIdSelected?.dcIdSelected}`}</span>}
                                    </>
                                ) : (
                                    <>
                                        <span>{"Ad Effectiveness"}</span>
                                    </>
                                )}
                                {(drillIdSelected?.categoryIdSelected!=undefined) || 
                                (drillIdSelected?.categoryIdSelected && String(drillIdSelected?.categoryIdSelected)?.length > 0) && tableData ? (
                                    <>
                                        <>{" > "}</>
                                        <span
                                            className="underline underline-offset-2 text-blue-500"
                                            onClick={() => handleAdEffectiveness(2)}
                                        >
                                            <a
                                                href=""
                                                onClick={($event) => {
                                                    $event.preventDefault();
                                                }}
                                            >
                                                {drillIdSelected?.dcIdSelected}
                                            </a>
                                        </span>
                                        {drillIdSelected?.categoryIdSelected && !drillIdSelected?.subCategoryIdSelected && <span>{` > ${drillIdSelected?.categoryIdSelected}`}</span> }
                                    </>
                                ) : (<></>)}
                                {(drillIdSelected?.subCategoryIdSelected!=undefined) || 
                                (drillIdSelected?.subCategoryIdSelected && String(drillIdSelected?.subCategoryIdSelected)?.length > 0) && tableData ? (
                                    <>
                                        <>{" > "}</>
                                        <span
                                            className="underline underline-offset-2 text-blue-500"
                                            onClick={() => handleAdEffectiveness(3)}
                                        >
                                            <a
                                                href=""
                                                onClick={($event) => {
                                                    $event.preventDefault();
                                                }}
                                            >
                                                {drillIdSelected?.categoryIdSelected}
                                            </a>
                                        </span>
                                        {drillIdSelected?.subCategoryIdSelected && <span>{` > ${drillIdSelected?.subCategoryIdSelected}`}</span>}
                                    </>
                                ) : (<></>)}
                            </h3>
                            {<div className="flex gap-2">
                                <img src={reload} alt="reload" className="w-[1vw]" />
                                <p className="text-fs16 text-[#858585] font-semibold">Last Updated : <span>{moment(lastUpdated?.slice(0, 10)).format("M/DD/YYYY")}</span></p>
                            </div>}
                        </div>

                        {isVisible && (
                            <div className="grid grid-cols-[1fr_auto] items-end gap-1">

                                <div className="grid grid-cols-10 gap-2 items-end">
                                    {filters &&
                                        Object.entries(filters).map(([filterKey, filterArray]: [string, any[]], index) => {
                                            // Determine if the current filter is the "class" filter
                                            const isClassFilter = filterKey === 'class';

                                            return (
                                                <div
                                                    key={filterKey}
                                                >
                                                    <FilterComponent
                                                        loading={isFilterLoading}
                                                        filterKey={filterKey}
                                                        filterName={filterNamesMap[filterKey] || formatFilterName(filterKey)}
                                                        options={filterArray
                                                            .filter(opt => opt?.filterValue || opt?.filterVal)
                                                            .map(opt => ({
                                                                label: opt.filterValue || opt.filterVal || "",
                                                                value: opt.filterValue || opt.filterVal || "",
                                                            }))}
                                                        labelKey="label"
                                                        valueKey="value"
                                                        value={selectedFilterData[filterKey] || []}
                                                        onFilterChange={handleFilterChange}
                                                        onDropdownOpen={callForecastFilterApi}
                                                    />
                                                </div>
                                            );
                                        })}
                                </div>

                                {/* Action Buttons */}
                                <div className="align-right flex justify-end gap-1">
                                    <Button onClick={removeHandler} className="bg-[#949494] text-white px-[20px] h-[4vh] rounded font-semibold btn-text">
                                        Clear
                                    </Button>
                                    <Button onClick={applyHandler} className="bg-deloitteGreen text-white px-[20px] h-[4vh] rounded font-semibold btn-text">
                                        Apply
                                    </Button>
                                </div>
                            </div>

                        )}
                        <div onClick={filterShowHandler} className="flex justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer z-[10]">
                            {isVisible && <img className="w-[1.5vw]" src={upArrow} alt="upArrow" />}
                            {!isVisible && <img className="w-[1.5vw]" src={downArrow} alt="downArrow" />}
                        </div>
                    </div>
                </div>
                {/* Table */}
                <div className="w-full h-[53vh] grow">
                    <Table
                        data={sortedData ? sortedData : []}
                        wordWrap
                        bordered
                        cellBordered
                        hover
                        rowHeight={20}
                        headerHeight={120}
                        fillHeight={true}
                        sortColumn={sortColumn}
                        sortType={sortType}
                        onSortColumn={handleSortColumn}
                        className="table-container"
                        rowClassName={(rowData, rowIndex) => {
                            if (!rowData) return "";
                            const key = `${rowData.id}_${rowData.Item}`;
                            let className = "rs-table-row"; // Default class for all rows

                            // Alternate row background for even rows
                            if (rowIndex % 2 === 0) {
                                className += " db-tablebg";
                            }

                            // Highlight only the selected row
                            if (key === "") {
                                className += " rs-row-selection";
                            }

                            return className;
                        }}
                        onRowClick={(rowData) => handleRowClick(rowData)}
                    >
                        <ColumnGroup  align="left" verticalAlign="middle"  header={
                            <div className="table-header-title font-semibold">
                                Week Start Date
                            </div>}  fixed>
                            <Column verticalAlign="middle" align="left" minWidth={100} fixed sortable>
                                <HeaderCell style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                    <div className="header-content table-header-title font-semibold">
                                        DC
                                    </div>
                                </HeaderCell>
                                <Cell dataKey="DC">
                                    {(rowData) =>
                                        drillIdSelected?.dcIdSelected && isSuccess ? (
                                            <>{rowData["DC"]}</>
                                        ) : (
                                            <span className="underline underline-offset-2 text-blue-500 table-cell-title font-normal">
                                                <a
                                                    href=""
                                                    onClick={($event) => {
                                                        $event.preventDefault();
                                                    }}
                                                >
                                                    {rowData["DC"]}
                                                </a>
                                            </span>
                                        )
                                    }
                                </Cell>
                            </Column>
                            
                            {drillIdSelected?.dcIdSelected && isSuccess && (
                                <Column verticalAlign="middle" align="center" width={150} fixed>
                                    <HeaderCell> <div className="header-content table-header-title font-semibold">
                                        Category
                                    </div></HeaderCell>
                                    <Cell dataKey="category">
                                        {(rowData) =>
                                            drillIdSelected?.categoryIdSelected && isSuccess ? (
                                                <>{rowData["category"]}</>
                                            ) : (
                                                <span className="underline underline-offset-2 text-blue-500 table-cell-title font-normal">
                                                    <a
                                                        href=""
                                                        onClick={($event) => {
                                                            $event.preventDefault();
                                                        }}
                                                    >
                                                        {rowData["category"]}
                                                    </a>
                                                </span>
                                            )
                                        }
                                    </Cell>
                                </Column>
                            )}

                            {drillIdSelected?.categoryIdSelected && isSuccess && (
                                <Column verticalAlign="middle" align="center" width={150} fixed>
                                    <HeaderCell> <div className="header-content table-header-title font-semibold">
                                        Sub Category
                                    </div></HeaderCell>
                                    <Cell dataKey="subCategory">
                                        {(rowData) =>
                                            drillIdSelected?.subCategoryIdSelected && isSuccess ? (
                                                <>{rowData["subCategory"]}</>
                                            ) : (
                                                <span className="underline underline-offset-2 text-blue-500 table-cell-title font-normal">
                                                    <a
                                                        href=""
                                                        onClick={($event) => {
                                                            $event.preventDefault();
                                                        }}
                                                    >
                                                        {rowData["subCategory"]}
                                                    </a>
                                                </span>
                                            )
                                        }
                                    </Cell>
                                </Column>
                            )}

                            {drillIdSelected?.subCategoryIdSelected && isSuccess && (
                                <Column verticalAlign="middle" align="center" width={150} fixed>
                                    <HeaderCell> <div className="header-content table-header-title font-semibold">
                                        Item ID
                                    </div></HeaderCell>
                                    <Cell dataKey="itemid" />
                                </Column>
                            )}

                        </ColumnGroup>

                       {Array.isArray(weeks) && weeks?.map((week: string) => (
    <ColumnGroup
        key={week}
        verticalAlign="middle"
        align="center"
        header={<div className="flex justify-center table-header-title font-semibold">{week}</div>}
    >
        <Column
            verticalAlign="middle"
            align="left"
            key={`${week}_adType`}
            width={150}
        >
            <HeaderCell><div className="header-content table-header-title font-semibold">
                Ad Type
            </div></HeaderCell>
            <Cell dataKey={`${week}_adType`}>
                {(rowData) => (
                    <div className="table-cell-title font-normal">
                        {rowData[`${week}_adType`]}
                    </div>
                )}
            </Cell>
        </Column>

        <Column
            verticalAlign="middle"
            align="left"
            key={`${week}_unitPrice`}
            width={120}
        >
            <HeaderCell><div className="header-content table-header-title font-semibold">
                Unit Price
            </div></HeaderCell>
            <Cell dataKey={`${week}_unitPrice`}>
                {(rowData) => (
                    <div className="table-cell-title font-normal">
                        {rowData?.[`${week}_unitPrice`] !== undefined
                            ? `$${rowData[`${week}_unitPrice`]}`
                            : ''}
                    </div>
                )}
            </Cell>
        </Column>

        <Column
            verticalAlign="middle"
            align="left"
            key={`${week}_volumeAdLift`}
            width={170}
        >
            <HeaderCell flexGrow={1} style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                <div className="header-content table-header-title font-semibold">
                    Volume Ad Lift ($/Cs)
                </div>
            </HeaderCell>
            <Cell dataKey={`${week}_volumeAdLift`}>
                {(rowData) => (
                    <div className="table-cell-title font-normal">
                        {rowData[`${week}_volumeAdLift`]}
                    </div>
                )}
            </Cell>
        </Column>
    </ColumnGroup>
))}
                    </Table>
                </div>
            </div>
            <div className="h-[6vh] bg-[#fff]">
                <div className="py-[0.5vh] px-[1vh] text-fs16 bg-[#f1f1f1]">
                    <span className=" table-header-title font-normal underline underline-offset-2 text-blue-500">
                        DC
                    </span>{","}{" "}
                    <span className=" table-header-title font-normal underline underline-offset-2 text-blue-500">
                        Category
                    </span>{" "}{"and "}
                    <span className=" table-header-title font-normal underline underline-offset-2 text-blue-500">
                        Sub Category
                    </span>{" "}
                    can be drilled down
                </div>
            </div>
            {(isLoading || isFilterLoading )&& <CustomLoader open={isLoading || isFilterLoading}/>}
        </>
    )
}

export default AdEffectiveness